// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610211150/js/" + chunkId + "." + {"44":"9ab50e47","225":"680208f8","481":"6be8f7bc","486":"6b7593f5","770":"d0f7ab5c"}[chunkId] + ".0.9679904729727397.chunk.js";
};